import { initializeApp } from "firebase/app";
import { initializeFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCG1QXg4UL6VoZ-0YgVFYrHJMTg4cl16zA",
  authDomain: "game-6f441.firebaseapp.com",
  projectId: "game-6f441",
  storageBucket: "game-6f441.firebasestorage.app",
  messagingSenderId: "628797020422",
  appId: "1:628797020422:web:e89f4c9d317ebd3323e687",
  measurementId: "G-NW3M0PGW4F"
};


const app = initializeApp(firebaseConfig);


export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true, 
});